<div class="bg-component-inner border border-secondary-border rounded-xl shadow-sm mb-6 overflow-hidden w-full">
  <div class="bg-alt-background px-4 py-3 border-b border-secondary-border flex justify-between items-center gap-4">
    <div class="flex items-center gap-3 flex-wrap">
      <span class="font-bold text-primary-text">{{ event.title }}</span>
      <nz-tag class="!m-0 bg-component-inner border-secondary-border">
        <i class="fas fa-table mr-1 text-primary"></i>
        <span class="font-mono">{{ modelTitle() }}</span>
      </nz-tag>
    </div>
    <span class="text-xs text-secondary-text whitespace-nowrap shrink-0">{{ event.timestamp | date:'shortTime' }}</span>
  </div>

  <div class="p-4 bg-component-inner custom-scrollbar overflow-x-auto max-h-[500px]">
    @if (event.operationType === 'DELETE') {
    <div class="bg-danger/10 border border-danger/20 rounded-lg p-4 text-danger flex items-start gap-3">
      <i class="fas fa-trash-alt mt-1"></i>
      <div class="flex flex-col w-full">
        <span class="font-bold">{{ config.texts.recordsDeleted }}</span>
        <span class="font-mono text-sm mt-1 break-all">{{ event.recordIds.join(', ') }}</span>

        @if (data && data.length > 0) {
        <div class="mt-4 border-t border-danger/20 pt-4 w-full text-primary-text">
          @if (data.length === 1) {
          <rapider-json-viewer [data]="data[0]"
                               [maxLineToDisplay]="15"
                               class="w-full opacity-80"></rapider-json-viewer>
          } @else {
          <div class="opacity-80">
            <rapider-list-grid [config]="gridConfig()"
                               [data]="data"></rapider-list-grid>
          </div>
          }
        </div>
        }
      </div>
    </div>
    } @else if (isLoading) {
    <div class="animate-pulse flex flex-col gap-3 p-2">
      <div class="h-4 bg-secondary-border rounded w-1/3"></div>
      <div class="h-24 bg-secondary-border rounded w-full"></div>
    </div>
    } @else if (!data || data.length === 0) {
    <div class="text-secondary-text text-sm italic p-2 flex items-center gap-2">
      <i class="fas fa-info-circle"></i> {{ config.texts.noData }}
    </div>
    } @else if (data.length === 1) {
    <rapider-json-viewer [data]="data[0]"
                         [classMap]="diffClassMap()"
                         [maxLineToDisplay]="15"
                         class="w-full"></rapider-json-viewer>
    } @else {
    <rapider-list-grid [config]="gridConfig()"
                       [data]="data"></rapider-list-grid>
    }
  </div>
</div>